import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { setProgressBarValue } from '../../../actions';

const ProgressBar = ({message}) => {
  const dispatch = useDispatch()
  
  
  const loadingPerformanceData = useSelector(state => state.fundData.loadingPerformanceData)
  const loadingCatchAll = useSelector(state => state.fundData.loadingCatchAll)
  const loadingAggregates = useSelector(state => state.fundData.loadingAggregates)
  const loadingConstituents = useSelector(state => state.fundData.loadingConstituents)
  const loadingRunID = useSelector(state => state.fundData.loadingRunID)
  const stop = !loadingPerformanceData && !loadingCatchAll && !loadingAggregates && !loadingConstituents
  let progressBarPercentage = useSelector(state => state.fundData.progressBarPercentage)
  if (isNaN(progressBarPercentage) || !progressBarPercentage) {
    progressBarPercentage = 0;
  }

  const [percentage, setPercentage] = useState(progressBarPercentage);
  const [progressSpeed, setProgressSpeed] = useState(150);
  const [progressIncrease, setProgressIncrease] = useState(.5);

  useEffect(() => {
    let interval = null;
    if (progressBarPercentage < 99) {
      interval = setInterval(() => {
        setPercentage(prevPercentage => {
          const newPercentage = Math.min(prevPercentage + progressIncrease, 100);
          dispatch(setProgressBarValue(newPercentage));
          if (newPercentage > 80) {
            setProgressSpeed(3000)
            setProgressIncrease(.5)
          }              
          if (newPercentage > 70) {
            setProgressSpeed(1000)
            setProgressIncrease(.5)
          }            
          if (newPercentage > 50) {
            setProgressSpeed(400)
            setProgressIncrease(.5)
          }          
          return newPercentage;
        });
      }, progressSpeed);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [percentage, dispatch, progressBarPercentage, progressIncrease, progressSpeed]);

  useEffect(() => {
    let newPercentage = percentage;

    if (!loadingRunID) {
        setPercentage(0);
        dispatch(setProgressBarValue(0))
    }

    // Ensure the percentage is not more than 100
    newPercentage = Math.min(newPercentage, 95);

    setPercentage(newPercentage);
    dispatch(setProgressBarValue(newPercentage))
    
    // If all data is loaded, reset the progress bar and stop rendering it
    if (!loadingPerformanceData && !loadingCatchAll && !loadingAggregates && !loadingConstituents) {
      setPercentage(0);
      dispatch(setProgressBarValue(0));
    }
    
  }, [loadingPerformanceData, loadingCatchAll, loadingAggregates, loadingConstituents, loadingRunID, stop, percentage, dispatch]);

  if (stop) {
    dispatch(setProgressBarValue(0))
    return null
  }

  return (
    <div style={{position: 'relative', width: '100%', backgroundColor: '#ddd', height: '20px', marginBottom: 30}}>
      <div style={{width: `${progressBarPercentage}%`, backgroundColor: '#050139', height: '20px', zIndex: 1}}></div>
      <div style={{position: 'absolute', width: '100%', textAlign: 'center', color: 'black', zIndex: 2}}>{message}</div>
    </div>
  );
};

export default ProgressBar;
